import React, { useEffect, useState } from 'react';

import {
  BasicDialog,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@opendoor/mosaic';

import { SearchVisits_trippy_searchVisits_visits } from '../../graphql/athena/types/SearchVisits';
import { useRejectVisit } from '../../graphql/mutations/trippy/useRejectVisit';
import VerticalLayout from '../layouts/VerticalLayout';

interface RejectVisitModalProps {
  visible: [
    SearchVisits_trippy_searchVisits_visits | null,
    React.Dispatch<React.SetStateAction<SearchVisits_trippy_searchVisits_visits | null>>,
  ];
}

const RejectVisitModal = ({ visible }: RejectVisitModalProps) => {
  const [visit, setVisit] = visible;
  const [rejectReason, setRejectReason] = useState('');
  const [otherReason, setOtherReason] = useState('');
  const [rejectVisit] = useRejectVisit();

  useEffect(() => {
    if (!visit) {
      setRejectReason('');
      setOtherReason('');
    }
  }, [visit]);

  const rejectButtonDisabled =
    rejectReason.length === 0 || (rejectReason === 'other' && otherReason.length === 0);

  const onRejectClick = async () => {
    if (!!visit && !rejectButtonDisabled) {
      const reason = rejectReason === 'other' ? otherReason : rejectReason;
      await rejectVisit({
        variables: {
          id: visit.id,
          reason: reason,
        },
        refetchQueries: ['SearchVisits'],
      });
      setVisit(null);
    }
  };

  const dialogContent = (
    <VerticalLayout style={{ height: '30vh' }}>
      <span style={{ marginBottom: 20, fontWeight: '600' }}>Select reason for rejecting job</span>
      <FormControl>
        <RadioGroup onChange={(e) => setRejectReason(e.target.value)}>
          <FormControlLabel
            value="Don't have time to complete on specified date"
            control={<Radio />}
            label="Don't have time to complete on specified date"
          />
          <FormControlLabel
            value="Outside of geo coverage"
            control={<Radio />}
            label="Outside of geo coverage"
          />
          <FormControlLabel value="other" control={<Radio />} label="Other" />
          {rejectReason === 'other' && (
            <TextField
              data-testid="other-selected-text-field"
              placeholder="Add reason"
              color="secondary"
              fullWidth
              onChange={(e) => {
                setOtherReason(e.target.value);
              }}
            />
          )}
        </RadioGroup>
      </FormControl>
    </VerticalLayout>
  );

  return (
    <BasicDialog
      title="Reject Job"
      open={!!visit}
      content={dialogContent}
      confirmLabel={'Reject'}
      showCancelButton
      onCancel={() => setVisit(null)}
      onConfirm={() => onRejectClick()}
      confirmDisabled={rejectButtonDisabled}
      dialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
    />
  );
};

export default RejectVisitModal;
